import tw from 'twin.macro';

export const PrimaryButton = tw.button`px-8 py-3 font-bold bg-primary-101 text-gray-100 focus:bg-primary-101 focus:text-gray-200 focus:shadow-outline focus:outline-none transition-all duration-300`;
